import { defineMessages } from 'react-intl';

export const giftCardRedemptionMessageMessages = defineMessages({
  heading: {
    defaultMessage: `To {recipient} from {sender}`,
    description: 'Gift Card Redemption Screen | Message | Heading',
  },
});
